import * as React from "react";
import TablaMediosContainer from "../pages/TablaMediosContainer";
import TablaDisposicionesContainer from "../pages/TablaDisposicionesContainer";
import TablaRecuperacionesContainer from "../pages/TablaRecuperacionesContainer";
import TablaUbicacionesContainer from "../pages/TablaUbicacionesContainer";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
// import "./button-group.css"

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function EnrutadorRegistros() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 5, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Ubicaciones" {...a11yProps(0)} />
          <Tab label="Disposiciones" {...a11yProps(1)} />
          <Tab label="Recuperación" {...a11yProps(2)} />
          <Tab label="Medio" {...a11yProps(3)} />
        </Tabs>
      </Box>

      <TabPanel value={value} index={3}>
        <TablaMediosContainer />
      </TabPanel>

      <TabPanel value={value} index={2}>
        <TablaRecuperacionesContainer />
      </TabPanel>

      <TabPanel value={value} index={1}>
        <TablaDisposicionesContainer />
      </TabPanel>

      <TabPanel value={value} index={0}>
        <TablaUbicacionesContainer />
      </TabPanel>
    </Box>
  );
}

export default EnrutadorRegistros;
